import { GET_DISABILITY_CHILDREN } from "../../../enums/Request/request.types";

export const getDisabilityChildrenAction = (data) => {
    return {
        type: GET_DISABILITY_CHILDREN,
        payload: data,
    }
}
